import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MeetingInformation from 'Components/UI/MeetingInformation/MeetingInformationTooltip';
import { ZoomButton } from './ZoomButton';

const styles = () => ({
  root: {},
});

const Meeting = ({
  className,
  classes,
  householdResource,
  meetingResource,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
    >
      <MeetingInformation
        householdResource={householdResource}
        meetingResource={meetingResource}
      />
      <ZoomButton
        meetingResource={meetingResource}
      />
    </div>
  );
};

Meeting.defaultProps = {
  className: '',
};

Meeting.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(Meeting);
